export enum RouteNames {
  Settings = 'Settings',
}
